document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".video-section__content");
  console.log("sections", sections);

  const isMobile = () => window.innerWidth < 1024;
  console.log("isMobile", isMobile());

  const loadAndPlayVideoInSection = (section) => {
    // Trouver l'élément deferred-media dans la section
    const deferredMedia = section.querySelector("deferred-media");
    if (!deferredMedia) {
      console.warn("Aucun élément deferred-media trouvé dans la section");
      return;
    }

    // Vérifier si le contenu est déjà chargé
    if (deferredMedia.getAttribute('loaded')) {
      // Le contenu est déjà chargé, on peut directement jouer la vidéo
      playVideoInSection(section);
    } else {
      // Charger le contenu différé d'abord
      const device = isMobile() ? 'mobile' : 'desktop';
      deferredMedia.loadContent(device, false);
      
      // Attendre que le contenu soit chargé puis jouer
      const checkLoaded = () => {
        if (deferredMedia.getAttribute('loaded')) {
          playVideoInSection(section);
        } else {
          // Attendre un peu plus si pas encore chargé
          setTimeout(checkLoaded, 100);
        }
      };
      checkLoaded();
    }
  };

  const playVideoInSection = (section) => {
    let video;

    if (isMobile()) {
      // On cherche une vidéo mobile s'il y en a une
      video = section.querySelector("video.template--mobile");
      if (!video) {
        // Si pas de vidéo mobile, on prend la desktop
        video = section.querySelector("video:not(.template--mobile)");
      }
    } else {
      // Desktop : on prend la vidéo desktop (non mobile)
      video = section.querySelector("video:not(.template--mobile)");
    }

    if (video && video.paused) {
      // Muter la vidéo par défaut
      video.muted = true;
      video.volume = 0;
      video.play().catch(() => {
        console.warn("Lecture automatique bloquée par le navigateur.");
      });
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        console.log("entry", entry);
        // Déclencher à 50% de la hauteur de la section
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          console.log("entry.isIntersecting at 50%", entry.isIntersecting);
          loadAndPlayVideoInSection(entry.target);
        }
      });
    },
    {
      // Observer avec un seuil de 50%
      threshold: 0.5
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});
